import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, BookOpen } from "lucide-react";

export default function TheoryStep({ sections, onDone }) {
  return (
    <div>
      <div className="space-y-4">
        {sections.map((s, i) => (
          <Card key={i} className="rounded-2xl border-[var(--ha-border)] bg-white">
            <CardContent className="p-6">
              <div className="flex items-start gap-3">
                <div className="h-8 w-8 rounded-xl bg-[var(--ha-primary)]/10 grid place-items-center shrink-0">
                  <BookOpen className="w-4 h-4 text-[var(--ha-primary)]" strokeWidth={1.75} />
                </div>
                <div>
                  <h3 className="font-bold text-[var(--ha-text)]">{s.heading}</h3>
                  <p className="mt-2 text-sm text-[var(--ha-muted)] leading-relaxed">{s.body}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-8 flex justify-end">
        <Button data-testid="theory-continue-btn" onClick={onDone} className="rounded-full bg-[var(--ha-primary)] hover:bg-[var(--ha-primary-hover)] text-white h-11 px-6">
          Continuar <ArrowRight className="w-4 h-4 ml-1.5" strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}
